<script setup>
// Inspector genérico (nome + subtítulo) para os nodes que ainda não têm painel
// dedicado. Os painéis específicos (agente, classificar, http, tools...) entram
// nas próximas iterações.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { NODE_META } from './nodeMeta';

const props = defineProps({ data: { type: Object, required: true } });
const emit = defineEmits(['update', 'remove', 'close']);
const { t } = useI18n();

const meta = computed(() => NODE_META[props.data.kind] || {});
const removable = computed(() => props.data.kind !== 'start');
</script>

<template>
  <div class="p-4">
    <div class="mb-3 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <span :class="meta.icon || 'i-lucide-box'" class="text-n-slate-11" />
        <h3 class="text-sm font-semibold text-n-slate-12">{{ meta.label }}</h3>
      </div>
      <button class="i-lucide-x text-n-slate-10" @click="emit('close')" />
    </div>

    <label class="mb-1 block text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.NAME') }}
    </label>
    <input
      :value="data.label"
      class="mb-3 w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm"
      @input="emit('update', { label: $event.target.value })"
    />

    <label class="mb-1 block text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.SUBTITLE') }}
    </label>
    <input
      :value="data.subtitle"
      :placeholder="t('AI_AGENTS.FLOW.OPTIONAL')"
      class="mb-3 w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm"
      @input="emit('update', { subtitle: $event.target.value })"
    />

    <p class="text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.GENERIC_HINT') }}
    </p>

    <button
      v-if="removable"
      class="mt-4 w-full rounded-lg border border-n-ruby-7 py-2 text-sm font-medium text-n-ruby-9 hover:bg-n-ruby-3"
      @click="emit('remove')"
    >
      {{ t('AI_AGENTS.FLOW.REMOVE_NODE') }}
    </button>
  </div>
</template>
